import { motion } from "framer-motion";

const ITEMS = [
  "Private Cooking Classes",
  "Fresh Pasta",
  "Craft Cocktails",
  "Seasonal Workshops",
  "Brunch Classes",
  "Youth Classes",
  "Charcuterie",
  "Desserts",
];

export default function EditorialMarquee() {
  const repeated = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <section className="relative bg-espresso text-ivory py-10 overflow-hidden border-y border-ivory/10" data-testid="editorial-marquee">
      <motion.div
        className="flex gap-16 whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-33.333%"] }}
        transition={{ duration: 40, ease: "linear", repeat: Infinity }}
      >
        {repeated.map((item, i) => (
          <span key={i} className="font-serif text-3xl md:text-5xl tracking-editorial italic font-light">
            {item}
            <span className="not-italic mx-10 text-terracotta">◆</span>
          </span>
        ))}
      </motion.div>
    </section>
  );
}
